import { resolveAvatarType } from './resolveAvatarType';
export const getDefaultAvatarType = type => {
  var _resolveAvatarType;
  return (_resolveAvatarType = resolveAvatarType(type)) === null || _resolveAvatarType === void 0 ? void 0 : _resolveAvatarType.defaultAvatarType;
};